import { Injectable } from "@angular/core";
import { APIService } from "./api.service";
import { Observable, from, switchMap, of, tap, catchError } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {
    constructor(private api: APIService) { }

    getWelcomeDetails(type: string) {
        return this.api.get(`/ConfigurationCoreIntegrator/getwelcomesetails?type=${type}`);
    }

    getFileSizes() {
        return this.api.get(`/ConfigurationCoreIntegrator/getfilesize`);
    }

    getCountries() {
        return this.api.get(`/AuthCoreIntegrator/getcountries`);
    }

    verifyPin(pin: any) {
        return this.api.post(`/ConfigurationCoreIntegrator/verifypin?pin=${pin}`, {});
    }


    getSectionDetails(type: string) {
        return this.api.get(`/ConfigurationCoreIntegrator/getsectiondetails?type=${type}`);
    }
    getAllSectionDetails() {
        return this.api.get(`/ConfigurationCoreIntegrator/getAllSectionDetails`);
    }

    getWelcomeConfigurationByType(type: string) {
        return this.api.post(`/ConfigurationCoreIntegrator/getWelcomeConfigurationByType?type=${type}`, {});
    }


    getBannerByType(type: string) {
        return this.api.get(`/ConfigurationCoreIntegrator/getbannerbytype?type=${type}`);
    }
    getAlreadyCustomerSectionDetails() {
        return this.api.get(`/ConfigurationCoreIntegrator/getalreadycustomersectiondetails`);
    }

    /** Portal flag: whether i18n / language selection is enabled (used by landing + profile). */
    getEnableTranslation() {
        return this.api.get(`/ConfigurationCoreIntegrator/getEnableTranslation`);
    }
    getallsocialmedialinks() {
        return this.api.post(`/ConfigurationCoreIntegrator/getallsocialmedialinks`, "");
    }
    gettermsandconditions() {
        return this.api.post(`/ConfigurationCoreIntegrator/gettermsandconditions`, "");
    }
    getReversalThresholdAmount() {
        return this.api.get(`/ConfigurationCoreIntegrator/getReversalThresholdAmount`);
    }

    getOTPConfigurationByUseCase(useCaseName: string) {
        return this.api.get(`/ConfigurationCoreIntegrator/getotpconfigurationbyusecase?useCaseName=${useCaseName}`);
    }
    getPortalConfigurations() {
        return this.api.get(`/ConfigurationCoreIntegrator/getPortalConfigurations`);
    }

    viewUploadFileInformation() {
        return this.api.get(`/ConfigurationCoreIntegrator/viewuploadfileinformation`);
    }

    getAllDropdownConfigurations() {
        return this.api.get(`/CompanyCoreIntegration/getAllDropdownConfigurations`);
    }

    getFieldValidationsByUseCase(useCaseName: string) {
        return this.api.get(`/ConfigurationCoreIntegrator/getfieldvalidationsbyusecase?useCaseName=${useCaseName}`);
    }

    getInteropConfigurations() {
        return this.api.get('/ConfigurationCoreIntegrator/getInteropConfigurations');
    }
    
    getLanguagesList() {
        return this.api.get('/LanguageManagement/getLanguages');
    }

    saveUserLanguage(languageCode: string) {
        return this.api.post('/ConfigurationCoreIntegrator/saveUserLanguage', {
            languageCode,
        });
    }

}
